import { useQuery } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

export const useGlobalApproverSettings = (enabled: boolean, queryKey = ['globalApprovers']) => {
  return useQuery({
    queryKey,
    enabled: enabled ?? false,
    staleTime: 5 * 60 * 1000,
    retry: 2,
    queryFn: async () => {
      const { data } = await axios.get(`${baseUrl}/aws/approvers/config`)

      // If the API returns [] on no data
      if (!Array.isArray(data)) return {}

      // Convert list of items into a category → approvers[] map
      return data.reduce((acc, item) => {
        const category = item.SK.split('#')[1]
        acc[category] = item.approvers
        return acc
      }, {} as Record<string, string[]>)
    },
  })
}
